import React from 'react'

type Props = { label: string, isRequired: boolean, htmlFor?: string, helpText?: string }
const FormLabel: React.FC<Props> = ({ label, isRequired, htmlFor, helpText }) => {
  const labelElement =  <label htmlFor={htmlFor} className='font-medium'>{label} {isRequired ? <span className='text-red-500'>*</span> : ''}</label>

  if(!helpText) { return labelElement }

  return (
    <div className='flex justify-between items-center'>
      {labelElement}
      <div className='text-xs text-gray-500 text-right'>
        {helpText}
      </div>
    </div>
  )
}

export default FormLabel
